
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"132","height":"132"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M65.599.018C29.37.018 0 29.387 0 65.617c0 36.228 29.37 65.599 65.599 65.599s65.598-29.371 65.598-65.599c0-36.23-29.369-65.599-65.598-65.599zM35.925 111.462l4.501-22.035.061-.363c.733-5.43 5.417-9.525 10.896-9.525h3.267c3.347 1.726 7.045 2.477 10.949 2.477 3.903 0 7.602-.751 10.948-2.477h3.757c5.48 0 10.163 4.095 10.896 9.524l4.51 22.133c-8.643 5.728-18.988 9.086-30.111 9.086-10.94 0-21.118-3.263-29.674-8.82zm29.674-40.379c-8.186 0-16.4-9.797-16.4-19.133 0-8.781 7.619-16.4 16.4-16.4 8.781 0 16.4 7.619 16.4 16.4 0 9.336-8.215 19.133-16.4 19.133zm39.627 32.081l-3.219-15.757c-1.199-8.334-7.081-15.042-14.732-17.633 3.243-4.867 5.657-11.905 5.657-17.824 0-14.833-12.5-27.333-27.333-27.333-14.833 0-27.333 12.5-27.333 27.333 0 5.973 2.449 13.063 5.747 17.957-7.456 2.686-13.153 9.311-14.333 17.5l-3.308 16.196c-9.536-9.845-15.439-23.23-15.439-37.986 0-30.143 24.523-54.666 54.666-54.666 30.143 0 54.665 24.523 54.665 54.666 0 14.542-5.745 27.743-15.038 37.547z"}})])
          )
        }
      }
    